class CriteriaToggle {
	constructor(config) {
		this.config = Object.assign({
			scope: '.js-criteria-toggle',
			criteria: 'div.ha-searcher__criteria',
			closeClass: 'criteria-close',
			closeLabel: 'Sluiten',
			activeClass: 'active'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this.observe();
	}

	addEventListeners() {
		$(document).on('click', this.config.scope, this.toggle.bind(this));
		$(document).on('click', '.' + this.config.closeClass, this.close.bind(this));
	}

	observe() {
		this.observer = new MutationObserver(() => {
			if (this.$criteria().length) {
				this.addCloseButton();
				this.observer.disconnect();
			}
		});

		this.observer.observe(document.body, { childList: true, subtree: true });
	}

	$criteria() {
		return $(this.config.criteria);
	}

	addCloseButton() {
		let $criteria = this.$criteria();

		if (!$criteria.length || $criteria.find('.' + this.config.closeClass).length) {
			return;
		}

		$('<a href="#" class="' + this.config.closeClass + ' d-block d-md-none" aria-label="' + this.config.closeLabel + '">&times;</a>')
			.prependTo($criteria);
	}

	toggle(event) {
		event.preventDefault();

		this.addCloseButton();
		this.$criteria().toggleClass(this.config.activeClass);
	}

	close(event) {
		event.preventDefault();
		this.$criteria().removeClass(this.config.activeClass);
	}
}

export default new CriteriaToggle;